export const validDataQuery = async () => {
  return {};
};

export const apiDefaultWithParams = async () => {
  return {};
};
